module.exports = __webpack_public_path__ + "media/navi/photo_keyflow_4-fb7b7b5c.png";